import { Guide, PageHandle } from "../logic/Guide"
import FirstPageIcon from '@mui/icons-material/FirstPage';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';

type PageViewerToolbarProps = {
    guide: Guide
    handle: PageHandle
    onNavigate: (target?: PageHandle) => void
}

export const PageViewerToolbar = ({ guide, onNavigate, handle } : PageViewerToolbarProps) => {
    const previousHandle = guide.previousPage(handle)
    const nextHandle = guide.nextPage(handle)
    const firstHandle = guide.defaultPageHandle()
    const previous = guide.getPage(previousHandle)
    const next = guide.getPage(nextHandle)
    const first = guide.getPage(firstHandle)
    return <>
        <nav className='d-print-none toolbar'>
            {first && <a className="btn btn-sm btn-success" onClick={() => onNavigate(firstHandle)}><FirstPageIcon/> Start</a>}
            {previous && <a className="btn btn-sm btn-success" onClick={() => onNavigate(previousHandle)}><SkipPreviousIcon/> {previous[1].title}</a>}            
            {next && <a className="btn btn-sm btn-success" onClick={() => onNavigate(nextHandle)}><SkipNextIcon/> {next[1].title}</a>}
        </nav>
    </>;
}
